import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CoreSharedModule } from '@vendasta/shared';
import { VaFormsModule } from '@vendasta/forms';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { LexiconModule } from '@galaxy/lexicon';
import { VaBadgeModule, VaIconModule } from '@vendasta/uikit';
import baseTranslation from '../assets/i18n/en_devel.json';
import { VaHeaderContainerModule } from '../header-container/header-container.module';
import { VaPricingModule } from '../pricing/pricing.module';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { StoreCardModule } from '../store-card.module';
import { DropDownFormSectionComponent } from './dropdown-form-section/dropdown-form-section.component';
import { FieldBuilderComponent } from './fields/field-builder/field-builder.component';
import { FieldComponent } from './fields/field.component';
import { FieldService } from './fields/field.service';
import { OrderFormSectionComponent } from './order-form-section/order-form-section.component';
import { OrderFormComponent } from './order-form/order-form.component';
import { OrderFormService } from './order-form/order-form.service';
import { OrderItemCompactComponent } from './order-item-list/order-item-compact/order-item-compact.component';
import { OrderItemListComponent } from './order-item-list/order-item-list.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { BillingService } from '@galaxy/billing';
import { BuildTemporaryStorageKeyPipe } from '../shared/build-temporary-storage-key.pipe';
import { BillingUiModule } from '@vendasta/billing-ui';
import { ItemCommonModule } from '@galaxy/inventory-ui';
import { SanitizeCheckboxLabelPipe } from './fields/field-checkbox';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatCardModule,
    MatTooltipModule,
    ReactiveFormsModule,
    VaFormsModule,
    VaHeaderContainerModule,
    VaIconModule,
    VaFormsModule,
    VaBadgeModule,
    MatListModule,
    CoreSharedModule,
    VaPricingModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    StoreCardModule,
    GalaxyPipesModule,
    GalaxyFormFieldModule,
    GalaxyUploaderModule,
    BuildTemporaryStorageKeyPipe,
    BillingUiModule,
    ItemCommonModule,
    SanitizeCheckboxLabelPipe,
  ],
  declarations: [
    DropDownFormSectionComponent,
    FieldComponent,
    OrderFormSectionComponent,
    OrderFormComponent,
    FieldBuilderComponent,
    OrderItemListComponent,
    OrderItemCompactComponent,
  ],
  exports: [
    DropDownFormSectionComponent,
    FieldComponent,
    OrderFormSectionComponent,
    OrderFormComponent,
    FieldBuilderComponent,
    OrderItemListComponent,
    OrderItemCompactComponent,
  ],
  providers: [FieldService, OrderFormService, BillingService],
})
export class VaOrderFormModule {}
